import { CustomModal } from "components/CustomModal"
import { useAppDispatch, useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { getTintVTOService } from "services/tintvto"
import { setUserStatus } from "store/user/userSlice"
import { Box, Typography } from "@strapi/design-system"
import ActivateAccountHubspotForm from "./ActivateAccountHubspotForm"

export const ActivateAccount = () => {
  const { t } = useTranslation()
  const service = getTintVTOService()
  const dispatch = useAppDispatch()
  const userInfo = useAppSelector((state) => state.user.userInfo)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleHubspotSubmitClick = () => {
    setIsModalOpen(false)
  }

  const getMerchantStatus = async () => {
    if (userInfo?.merchantId) {
      const { data } = await service.merchantStatus(userInfo.merchantId)
      if (data?.merchantStatus) dispatch(setUserStatus(data.merchantStatus))
    }
  }

  useEffect(() => {
    setIsModalOpen(true)
    getMerchantStatus()
  }, [])

  return (
    <Box>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CustomModal
          showCloseButton={false}
          isOpen={isModalOpen}
          title={t("activateAccount.supportTeamTitle")}
          startTitleIcon={<img src={"/tint-logo-small.svg"} alt="" />}
        >
          <Box
            style={{
              width: "350px",
              marginTop: "15px",
              minHeight: "350px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="delta"
                fontWeight="bold"
                style={{ textAlign: "center", marginBottom: "16px" }}
              >
                {t("activateAccount.assistanceNeededTitle")}
              </Typography>
              <Typography style={{ textAlign: "center", marginBottom: "24px" }}>
                {t("activateAccount.assistanceDescription")}
              </Typography>
            </Box>

            <ActivateAccountHubspotForm onSubmit={handleHubspotSubmitClick} />

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                gap: 4,
                marginTop: "10px",
              }}
            >
              <Typography variant="epsilon" textAlign="center" marginTop={2}>
                {t("activateAccount.or")}
              </Typography>
              <a
                href="https://www.banuba.com/support-tint"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontWeight: "700",
                  color: "#4846F6",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "14px",
                  lineHeight: "21px",
                }}
              >
                {t("activateAccount.contactSupport")}
              </a>
              <Typography variant="epsilon" textAlign="center" marginTop={2}>
                {t("activateAccount.team")}
              </Typography>
            </Box>
          </Box>
        </CustomModal>

        {!isModalOpen && (
          <Box
            style={{
              height: "100vh",
              width: "350px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              textAlign: "center",
            }}
          >
            <Typography variant="delta" fontWeight="bold">
              {t("activateAccount.successTitle")}
            </Typography>
            <Typography>{t("activateAccount.successDescription")}</Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default ActivateAccount
